// Copyright (c) StrangeBee 2023

import React, { ReactElement, ReactNode } from 'react';
import { Space } from 'antd';
import { ICONS } from '@Constants/iconsApp';

import './ConfirmButtons.scss';

interface ConfirmButtonsProps {
    onConfirm: () => void;
    onCancel: () => void;
    disabled?: boolean;
    children?: ReactNode;
}

const ConfirmButtons = ({ onConfirm, onCancel, disabled, children }: ConfirmButtonsProps): ReactElement => {
    return (
        <Space className="confirm-buttons">
            {children}
            <ICONS.CheckIcon
                onClick={(): void => {
                    !disabled && onConfirm();
                }}
                className={disabled ? 'disabled' : ''}
            />
            <ICONS.CloseIcon onClick={onCancel} />
        </Space>
    );
};

export default ConfirmButtons;
